import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { CouponsetAttributes } from '../models/merchant.model';

export const CouponSetTitleChanged = createAction(
  '[Merchant: CouponSets]: CouponSet Title Changed',
  props<{ couponsetTitle: string }>(),
);

export const ValidFromDateFromChanged = createAction(
  '[Merchant: CouponSets]: Valid From Date From Changed',
  props<{ validFrom: Date; validFromText: string }>(),
);

export const ValidFromDateFromCleared = createAction('[Merchant: CouponSets]: Valid From Date From Cleared');

export const ValidUntilDateFromChanged = createAction(
  '[Merchant: CouponSets]: Valid Until Date From Changed',
  props<{ validUntil: Date; validUntilText: string }>(),
);

export const ValidUntilDateFromCleared = createAction('[Merchant: CouponSets]: Valid Until Date From Cleared');

export const VATNumberChanged = createAction(
  '[Merchant: CouponSets]: VAT Number Changed',
  props<{ vatNumber: string }>(),
);

export const FirstNameChanged = createAction(
  '[Merchant: CouponSets]: First Name Changed',
  props<{ firstName: string }>(),
);

export const LastNameChanged = createAction('[Merchant: CouponSets]: Last Name Changed', props<{ lastName: string }>());

export const EmailAddressChanged = createAction(
  '[Merchant: CouponSets]: Email Address Changed',
  props<{ email: string }>(),
);

export const RegisterCouponSetAttributes = createAction(
  '[Merchant: CouponSets]: Register CouponSet Attributes',
  props<{ couponSetAttributes: CouponsetAttributes }>(),
);

export const CouponSetAddAttribute = createAction('[Merchant: CouponSets]: CouponSet Add Attribute');

export const CancelCAAddition = createAction('[Merchant: CouponSets]: Cancel CouponSet Attribute Addition');

export const DeleteAttributeRow = createAction('[Merchant: CouponSets]: Delete Attribute Row', props<{ id: string }>());

export const SaveAttribute = createAction('[Merchant: CouponSets]: Save Attribute');

export const SaveValidAttribute = createAction('[Merchant: CouponSets]: Save Valid Attribute');

export const NewAttributeDateChanged = createAction(
  '[Merchant: CouponSets]: New Attribute Date Changed',
  props<{ attributeDate: Date; attributeDateText: string }>(),
);

export const AttributeBoolValueChanged = createAction('[Merchant: CouponSets]: Attribute Boolean Value Changed');

export const ClearAttributeDateValue = createAction('[Merchant: CouponSets]: Clear Attribute Date Value');

export const SelectedValueChanged = createAction(
  '[Merchant: CouponSets]: Selected Value Changed',
  props<{ selectedValue: string }>(),
);

export const SelectedCodeChanged = createAction(
  '[Merchant: CouponSets]: Selected Code Changed',
  props<{ selectedCode: string }>(),
);

export const SelectedTypeChanged = createAction(
  '[Merchant: CouponSets]: Selected Type Changed',
  props<{ selectedType: string }>(),
);

export const SaveCouponSetAttributes = createAction('[Merchant: CouponSets]: Save CouponSet Attributes');

export const SaveCouponSetAttributesSuccess = createAction(
  '[Merchant: CouponSets]: Save CouponSet Attributes Success',
  props<{ res: any }>(),
);

export const SaveCouponSetAttributesFailed = createAction(
  '[Merchant: CouponSets]: Save CouponSet Attributes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const StringTableChanged = createAction(
  '[Merchant: CouponSets]: String Table Changed',
  props<{ text: string; index: number }>(),
);

export const ExistingBoolAttributeChanged = createAction(
  '[Merchant: CouponSets]: Existing Boolean Attribute Changed',
  props<{ index: number }>(),
);

export const ExistingAttributeDateChanged = createAction(
  '[Merchant: CouponSets]: Existing Attribute Date Changed',
  props<{ attributeDateText: string; index: number }>(),
);
